import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Inject,
  viewChild,
  Signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import {
  MatTreeModule,
  MatTreeNestedDataSource,
  MatTree,
} from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { HasRolesPipe } from '@thred/ng-shared';

export interface SideMenuNavNode {
  name: string;
  requiredRoles: string[];
  children?: SideMenuNavNode[];
  link?: string;
  collapse?: boolean;
}

@Component({
  selector: 'thred-side-menu',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    RouterModule,
    MatTreeModule,
    MatIconModule,
    HasRolesPipe,
  ],
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenuComponent implements AfterViewInit {
  childrenAccessor = (node: SideMenuNavNode) => node.children ?? [];
  dataSource = new MatTreeNestedDataSource<SideMenuNavNode>();

  tree: Signal<MatTree<SideMenuNavNode>> = viewChild.required('tree');

  constructor(
    @Inject('SIDE_MENU_TREE_DATA')
    private SIDE_MENU_TREE_DATA: SideMenuNavNode[],
  ) {
    this.dataSource.data = SIDE_MENU_TREE_DATA;
  }

  ngAfterViewInit() {
    this.dfsExpandSome(this.SIDE_MENU_TREE_DATA, 0, 3);
  }

  private dfsExpandSome(
    nodes: Array<SideMenuNavNode>,
    depth: number,
    maxDepth: number,
  ) {
    if (depth > maxDepth) {
      return;
    }
    for (const node of nodes) {
      if (node.collapse) {
        this.tree().collapse(node);
      } else {
        this.tree().expand(node);
        if (node.children) {
          this.dfsExpandSome(node.children, depth + 1, maxDepth);
        }
      }
    }
  }

  hasChild = (_: number, node: SideMenuNavNode) =>
    !!node.children && node.children.length > 0;
}
